/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import "@babel/polyfill";
import "./bootstrap";
import Vue from "vue";
import VueInternationalization from "vue-i18n";
import Locale from "./vue-i18n-locales.generated";
import { EventBus } from "./event-bus.js";
import router from "./routes";
import store from "./vuex/store";
import { sync } from "vuex-router-sync";

Vue.use(VueInternationalization);
const lang = document.documentElement.lang.substr(0, 2);
// or however you determine your current app locale

const i18n = new VueInternationalization({
  locale: lang,
  messages: Locale
});

sync(store, router);

// Define Main Vue Instance
new Vue({
  i18n,
  // router holds our view and layouts
  router,
  // store holds our state throughout our application
  store,
  // All Vue Js Life Cycle Hooks
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}).$mount("#app");
